import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "bankFilled"
const BankFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M21.75 21.938H2.25V20.063H21.75zM6.938 18.75H5.063V11.25H6.938zM12.938 18.75H11.062V11.25H12.939zM18.938 18.75H17.063V11.25H18.938zM11.503 2.434C11.763 2.246 12.102 2.222 12.381 2.363L12.497 2.434 20.458 8.224C21.118 8.704 20.778 9.75 19.961 9.75H4.04C3.22 9.75 2.88 8.705 3.542 8.224z" />
        </svg>
      }
    </span>
  )
}
export default BankFilledIcon
